'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _paths2 = require('../events/paths');

var _getAdjudicatorsForEvent = require('../events/getAdjudicatorsForEvent');

var _getAdjudicatorsForEvent2 = _interopRequireDefault(_getAdjudicatorsForEvent);

var _immutable = require('immutable');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id) {
  return function (dispatch, getState) {
    return dispatch((0, _getAdjudicatorsForEvent2.default)(feis_id, event_id)).then(function (data) {
      return data.payload.forEach(function (a) {

        var scoreSheetByAdjudicator = (0, _paths2.getEventScores)(getState(), event_id, a.id);

        if (scoreSheetByAdjudicator.size === 0) {
          dispatch(_defineProperty({
            feis_id: feis_id,
            event_id: event_id,
            adj_id: a.id
          }, _middleware.CALL_API, {
            config: {
              url: (0, _paths.feisPrefixUrl)(feis_id) + '/events/' + event_id + '/adjudicators/' + a.id + '/scores'
            },
            types: ['GET_SCORESHEET_START', 'GET_SCORESHEET', 'GET_SCORESHEET_ERROR']
          }));
        }
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scores/getScoresheets.js
// module id = 674
// module chunks = 0